import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function NewMission() {
    const cardsRef = useRef<(HTMLDivElement | null)[]>([]);
    const headingRef = useRef<HTMLHeadingElement | null>(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Check if the screen is mobile on initial load
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 768); // Common breakpoint for mobile
        };

        // Initial check
        checkIfMobile();

        // Add resize listener
        window.addEventListener('resize', checkIfMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    useEffect(() => {
        // Heading animation
        gsap.fromTo(
            headingRef.current,
            { y: 50, opacity: 0 }, // Start slightly below and transparent
            {
                y: 0,
                opacity: 1,
                duration: 1.2,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: headingRef.current,
                    start: 'top 85%',
                    toggleActions: 'play none none reverse',
                },
            }
        );

        // Cards animation
        gsap.fromTo(
            cardsRef.current,
            { y: 100, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                stagger: 0.2,
                duration: 1.2,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: cardsRef.current[0],
                    start: 'top 80%',
                    toggleActions: 'play none none reverse',
                },
            }
        );
    }, []);

    return (
        <div className='min-h-screen relative flex flex-col md:justify-end justify-center md:pb-24 font-sfui px-5'>
            {/* Responsive background image */}
            <img 
                src={isMobile ? "/assets/main_222.png" : "/assets/main_111.png"} 
                alt="" 
                className='absolute left-0 top-0 min-h-screen w-screen z-0' 
            />

            {/* Heading with animation */}
            <div className='relative z-20 md:mb-32 mb-10 lg:px-32 md:px-24 text-center'>
                <h1 ref={headingRef} className='lg:text-4xl md:text-3xl text-xl font-sfui capitalize'>
                    Empowering businesses with tailored, innovative solutions for seamless operations and long-term success.
                </h1>
            </div>

            <div className='relative z-20 flex flex-col gap-y-10 md:gap-y-0 md:flex-row md:px-10 lg:px-40 md:gap-x-20 gap-x-0'>
                <div
                    ref={(el) => (cardsRef.current[0] = el)}
                    className='md:w-1/2 w-full border relative rounded-lg md:px-7 px-3 py-4 text-center backdrop-blur-[6px] bg-[#ffffff28]  shadow-lg'
                >
                    <img src="/assets/mission.png" alt="" className='md:w-20 md:h-20 w-12 h-12 absolute md:-top-10 -top-5 left-[10%]' />
                    <h1 className='md:text-2xl text-xl md:mt-6 mt-2 font-bold font-sfui'>Mission</h1>
                    <p className='text-base mt-2 font-sfui font-light'>
                        We are concentrating all our capacities on developing customer-oriented tailored solutions and offering fast, accurate maintenance and service, ensuring seamless operations and long-term business success. With a commitment to excellence.
                    </p>
                </div>

                <div
                    ref={(el) => (cardsRef.current[1] = el)}
                    className='md:w-1/2 w-full border rounded-lg md:px-7 px-3 py-4 text-center backdrop-blur-[6px] relative bg-[#ffffff66]  shadow-lg'
                >
                    <img src="/assets/shared-vision.png" alt="" className='md:w-20 md:h-20 h-12 w-12 absolute md:-top-10 -top-5 md:left-[10%] left-[80%]' />
                    <h1 className='md:text-2xl text-xl md:mt-6 mt-2  font-sfui font-bold'>Vision</h1>
                    <p className='text-base mt-2 font-sfui font-light'>
                        To deliver quality and efficient technology solutions tailored to the retail industry, ensuring streamlined operations while prioritizing customer satisfaction. Our commitment lies in innovation and empowering businesses for long-term success.
                    </p>
                </div>
            </div>
        </div>
    );
}



